var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DiffHeader',{staticClass:"mb-6",attrs:{"mbB":_vm.value.before,"mbA":_vm.value.after}}),_c('DiffTable',{attrs:{"cols":_vm.cols,"pairs":_vm.pairs,"mbB":_vm.value.before,"mbA":_vm.value.after}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }